import { env } from '@/lib/runtime-env'

const ACCOUNT_SERVICE_BASE_PATH = '/SS'

export type AccountServiceResult<T> = {
  data?: T
  ok: boolean
  /** HTTP status code; `0` means the request failed before a response arrived. */
  status: number
}

export const fetchAccountService = async <T>(
  path: string,
  init?: RequestInit,
): Promise<AccountServiceResult<T>> => {
  try {
    const accountServer = env('NEXT_PUBLIC_ACCOUNT_SERVER')!
    const url = new URL(`${ACCOUNT_SERVICE_BASE_PATH}${path}`, accountServer).toString()
    const response = await fetch(url, init)
    const data = (await response.json().catch(() => undefined)) as T | undefined

    return {
      data,
      ok: response.ok,
      status: response.status,
    }
  } catch {
    return {
      ok: false,
      status: 0,
    }
  }
}
